import type { OrganizationDocumentTypeEnum } from '@acme/api';
import type { FilterOption } from '@acme/foundation';
import { FilterDropdown } from '@acme/foundation';
import { useMemo } from 'react';
import type {
  DocumentDatePeriod,
  OrganizationDocumentsFiltersValue,
} from '../../lib/filtertypes';

const ALL_DOCUMENT_TYPES = 0;

const periodOptions: FilterOption<DocumentDatePeriod>[] = [
  { value: 'all', label: 'Все время' },
  { value: '7d', label: '7 дней' },
  { value: '30d', label: '30 дней' },
];

export type OrganizationDocumentsFiltersProps = {
  value: OrganizationDocumentsFiltersValue;
  onChange: (next: OrganizationDocumentsFiltersValue) => void;
  documentTypeOptions: Array<{
    value: OrganizationDocumentTypeEnum;
    label: string;
  }>;
  className?: string;
};

export const OrganizationDocumentsFilters = ({
  value,
  onChange,
  documentTypeOptions,
  className = '',
}: OrganizationDocumentsFiltersProps) => {
  const optionsWithAll = useMemo(
    () => [
      { value: ALL_DOCUMENT_TYPES as number, label: 'Все' },
      ...documentTypeOptions.map((o) => ({
        value: o.value as number,
        label: o.label,
      })),
    ],
    [documentTypeOptions]
  );

  const documentTypeValue = value.documentTypeId ?? ALL_DOCUMENT_TYPES;

  return (
    <div
      className={`flex flex-wrap justify-between items-center gap-3 ${className}`}
    >
      <div className="flex items-center gap-3">
        <FilterDropdown<number>
          title="Тип документа"
          value={documentTypeValue}
          options={optionsWithAll}
          onChange={(v) =>
            onChange({
              ...value,
              documentTypeId:
                v === ALL_DOCUMENT_TYPES || v === undefined
                  ? undefined
                  : (v as OrganizationDocumentTypeEnum),
            })
          }
        />
        <FilterDropdown
          title="Период"
          value={value.period}
          options={periodOptions}
          onChange={(period) => onChange({ ...value, period: period ?? 'all' })}
        />
      </div>
    </div>
  );
};
